import script from "./3pMain.vue?vue&type=script&setup=true&lang=js"
export * from "./3pMain.vue?vue&type=script&setup=true&lang=js"

import "./3pMain.vue?vue&type=style&index=0&id=5cef6480&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cef6480"]])

export default __exports__